import { createAsyncThunk } from '@reduxjs/toolkit';
import ApiaApi from '../../../api/apiaApi/apiaApi';
import { notify } from '../../../components/common/notifications/util';
import { arrayOrArray, noNaN } from '../../../utils/util';
import { makeGridActionUrl } from '../actionsUtils';
import { TApiaXMLResponse, TDataGridThunkState } from '../types';
import { shouldDebugGridActions } from './add';
import { TRowActionResponse } from './types';
import { getSelectedRowsForSortEvent } from './up';
import propsStore from '../../propsStore/propsStore';
import fieldsStore from '../../../components/apia/execution/fieldsStore/fieldsStore';

const deleteRow = createAsyncThunk<
  TRowActionResponse | null,
  {
    gridId: string;
    rowIndex?: number | number[];
  },
  TDataGridThunkState
>('dataGridSlice/deleteRow', async ({ gridId, rowIndex }, thunkApi) => {
  const state = thunkApi.getState().dataGridSlice[gridId];
  const gridField = state.context.grid.field;
  const rowId =
    rowIndex !== undefined
      ? arrayOrArray(rowIndex).sort((a, b) => b - a)
      : getSelectedRowsForSortEvent(gridId);
  const currentPage = noNaN(gridField.curPage);
  const isPaged = gridField.properties.paged;
  const pageSize =
    isPaged && gridField.properties.pagedGridSize === undefined
      ? 5
      : Number(gridField.properties.pagedGridSize);
  const startIndex = noNaN(gridField.startIndex);
  const isFirstSelected = rowId[0] - startIndex === 0 && currentPage !== 0;

  const result = await ApiaApi.post<TApiaXMLResponse>(
    makeGridActionUrl({
      gridAction: 'delete',
      context: state.context,
      rowId,
    }),
  );
  if (shouldDebugGridActions) console.log('delete', result?.data);
  if (result?.data) {
    const maxRowIndexInThisPage = isPaged
      ? currentPage * pageSize
      : state.rows.length;

    const removeRowsCount = new Array(
      Math.max(
        0,
        Math.min(state.rows.length, maxRowIndexInThisPage) -
          Number.parseInt(result.data.rowCount),
      ),
    )
      .fill(1)
      .map((_, i) => state.rows.length - (i + 1));

    if (removeRowsCount.length > 0) {
      Object.keys(propsStore.getAllFields()).forEach((name) => {
        if (
          name.match(
            `^${state.context.grid.fieldId}_\\d+_(${removeRowsCount.join(
              '|',
            )})`,
          )
        ) {
          propsStore.removeField(name);
          fieldsStore.unregister(name);
        }
      });
    }
    return {
      focusGrid: false,
      focusRow: isFirstSelected ? pageSize : state.focusedRow - 1,
      newSelectedRows: isFirstSelected
        ? [pageSize]
        : state.selectedRows.map((current) => current - 1),
      xmlResponse: result?.data,
    };
  }

  notify({
    message: 'Error on DataGrid action',
    type: 'danger',
  });
  return null;
});

export default deleteRow;
